export const maxDateByDates = (dates: Date[]) =>
  new Date(Math.max(...dates.map(Number)))

export const minDateByDates = (dates: Date[]) =>
  new Date(Math.min(...dates.map(Number)))
